import { Component, Input, OnInit } from '@angular/core';

import { Booking } from '../../models';
import { Utilities } from '../../utilities/utilities';
import { ENV_CONFIG } from '../../../bin/env.config';


@Component({
  selector: 'smr-booking-item',
  templateUrl: 'smr-booking-item.component.html',
  styleUrls: ['smr-booking-item.component.scss'],
})

export class BookingItemComponent implements OnInit {

  @Input() booking: Booking;

  @Input() displayClientName: boolean = true;

  public statuses: { [id: string]: { name: string, class: string } };

  public env_config: any = ENV_CONFIG;

  constructor() {
    this.statuses = Utilities.getBookingStatuses();;
  }

  ngOnInit() {
  }
}
